module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_15.dot-2fba64d7086e3d08fc407d1129aabdfc.svg";